import axios from "axios";
import { toast } from "react-hot-toast";
const BASE_URL = process.env.NODE_ENV === "production" ? undefined : "http://localhost:8000";
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});
axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    console.error(error);
    if (
      (error.response?.status === 401 &&
        error.response?.data?.message === "Access denied") ||
      (error.response?.status === 500 &&
        error.response?.data?.message === "Internal server error")
    ) {
      localStorage.clear();
      window.location.href = "/login";
    }
    if (!error.response) {
      return Promise.reject(new Error("Network Error: Is the backend server running?"));
    }
    return error.response;
  },
);
export const apiConnector = async ({
  method,
  url,
  bodyData,
  params,
  headers,
}) => {
  const res = await axiosInstance({
    method: method ? `${method}` : null,
    url: url ? url : null,
    data: bodyData ? bodyData : null,
    headers: headers ? headers : null,
    params: params ? params : null,
  });

  return res;
};
